import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';

export const PriceAndCaloriesWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.priceAndCaloriesWrapper, style],
  });

export const CaloriesText = withTypography({ variant: 'copyTwo', style: { marginRight: 2 } });

export const Price = withTypography({ variant: 'copyTwo', bold: true });

const styles = StyleSheet.create({
  priceAndCaloriesWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
});
